import type {BuildTypeId, BuildTypeInternalId, ProjectId, ProjectInternalId} from '../../../types'

import type {HolderType, PolicyEntry, PolicyHolder} from './CleanupProjectPage.types'
import {getCleanupBuildTypeNode, getCleanupProjectNode} from './Listings/Rules/Rules.types'
import type {CleanupHolderNode} from './Listings/Rules/Rules.types'

type PolicyHolderIds =
  | {
      type: 'project'
      projectId: ProjectId
      projectInternalId: ProjectInternalId
      buildTypeId?: never
      buildTypeInternalId?: never
    }
  | {
      type: 'buildType'
      projectId?: never
      projectInternalId?: never
      buildTypeId: BuildTypeId
      buildTypeInternalId: BuildTypeInternalId
    }
export const getPolicyHolderIds = (
  {
    externalId,
    internalId,
  }: {
    internalId?: ProjectInternalId | BuildTypeInternalId
    externalId: ProjectId | BuildTypeId
  },
  type: HolderType,
): PolicyHolderIds =>
  (type === 'project'
    ? {
        type: 'project',
        projectId: externalId,
        projectInternalId: internalId,
      }
    : {
        type: 'buildType',
        buildTypeId: externalId,
        buildTypeInternalId: internalId,
      }) as any
export const getPolicyHolder = (
  internalId: ProjectInternalId | BuildTypeInternalId,
  holderType: HolderType,
): PolicyHolder =>
  ({
    holderId: internalId,
    holderType,
  }) as any
export function getHolderNode(policy: PolicyEntry, holderType: HolderType): CleanupHolderNode {
  const ids = getPolicyHolderIds(policy, holderType)
  const name = policy.name.split(' / ').pop()
  return ids.type === 'project'
    ? getCleanupProjectNode({
        id: ids.projectId,
        internalId: ids.projectInternalId,
        name,
      })
    : getCleanupBuildTypeNode({
        id: ids.buildTypeId,
        internalId: ids.buildTypeInternalId,
        name,
      })
}
